<template>
  <footer class="block py-4 ">
    <div class="container mx-auto px-4">
      <hr class="mb-4 border-b-1 border-blueGray-200" />
      <div
        class="flex flex-wrap items-center md:justify-between justify-center"
      >
        <div class="w-full md:w-4/12 px-4">
          <div
            class="text-sm text-bgbb-y font-semibold py-1 text-center md:text-left"
          >
          <!-- {{ date }} -->
            <a
              href="/"
              class="text-bgbb-y hover:text-blueGray-700 text-sm font-semibold py-1"
            >
BGBB.io           </a>
          </div>
        </div>
        <div class="w-full md:w-8/12 px-4">
          <ul class="flex flex-wrap list-none md:justify-end justify-center">
            
            
            <li>
              <a
                href="/staking"
                class="text-bgbb-y text-sm font-semibold block py-1 px-3"
              >
                Staking
              </a>
            </li>
            <li>
              <a
                href="/NFT-marketplace"
                class="text-bgbb-y text-sm font-semibold block py-1 px-3"
              >
                NFT Marketplace
              </a>
            </li>
            <li>
              <a
                href="/Bounty-and-Lottery"
                class="text-bgbb-y text-sm font-semibold block py-1 px-3"
              >
                Bounty & Lottery
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },
};
</script>
